/* LoveLEDLights Premium – Verhalten der lllp-Sections. Läuft beim Laden und nach jedem Neuladen im Theme-Editor. */
(function(){
  var RM=window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function each(root,sel,fn){[].forEach.call(root.querySelectorAll(sel),fn)}

  function hero(el){
    if(el.dataset.ok)return;el.dataset.ok=1;
    var st=el.querySelector('.st'),hd=el.querySelector('.hd'),sw=el.querySelector('.lllp-sw'),lbl=sw&&sw.querySelector('span');
    function set(p){el.style.setProperty('--x',p+'%');var lit=p<50;el.classList.toggle('lit',lit);if(sw){sw.setAttribute('aria-pressed',lit);lbl.textContent=lit?sw.dataset.off:sw.dataset.on}}
    set(+el.dataset.start||62);
    if(sw)sw.addEventListener('click',function(){set(el.classList.contains('lit')?100:0)});
    var d=false;
    function mv(e){if(!d)return;var r=st.getBoundingClientRect();set(Math.max(0,Math.min(100,(e.clientX-r.left)/r.width*100)))}
    hd.addEventListener('pointerdown',function(e){d=true;el.classList.add('drag');hd.setPointerCapture(e.pointerId)});
    hd.addEventListener('pointermove',mv);
    hd.addEventListener('pointerup',function(){d=false;el.classList.remove('drag')});
    if(el.dataset.auto==='true'&&!RM)setTimeout(function(){set(0)},1400);
  }

  function camp(el){
    if(el.dataset.ok)return;el.dataset.ok=1;
    var s=el.querySelectorAll('.lllp-camp a'),b=el.querySelectorAll('.lllp-dots button'),i=0,t,ms=(+el.dataset.speed||8)*1000;
    if(s.length<2)return;
    el.style.setProperty('--d',ms/1000+'s');
    function go(n){i=(n+s.length)%s.length;[].forEach.call(s,function(a,k){a.classList.toggle('on',k===i)});[].forEach.call(b,function(x,k){x.classList.remove('on');void x.offsetWidth;x.classList.toggle('on',k===i)});clearTimeout(t);t=setTimeout(function(){go(i+1)},ms)}
    [].forEach.call(b,function(x,k){x.addEventListener('click',function(){go(k)})});
    go(0);
  }

  function rail(el){
    if(el.dataset.ok)return;el.dataset.ok=1;
    var r=el.querySelector('.lllp-rail');
    each(el,'[data-dir]',function(b){b.addEventListener('click',function(){r.scrollBy({left:r.clientWidth*.8*b.dataset.dir,behavior:'smooth'})})});
  }

  function cats(el){
    if(el.dataset.ok)return;el.dataset.ok=1;
    var bs=el.querySelectorAll('.lllp-tabs button');
    [].forEach.call(bs,function(b){b.addEventListener('click',function(){
      var g=b.dataset.g;[].forEach.call(bs,function(x){x.setAttribute('aria-pressed',x===b)});
      each(el,'.lllp-ct',function(c){c.hidden=!(g==='*'||c.dataset.g===g)});
    })});
  }

  function stats(el){
    if(el.dataset.ok)return;el.dataset.ok=1;
    var nums=el.querySelectorAll('[data-to]');
    function fmt(v,n){return Math.round(v).toLocaleString(document.documentElement.lang||'de')+(n.dataset.suf||'')}
    [].forEach.call(nums,function(n){n.textContent=fmt(+n.dataset.to,n)});
    if(RM||!('IntersectionObserver' in window))return;
    var io=new IntersectionObserver(function(es){es.forEach(function(en){if(!en.isIntersecting)return;io.disconnect();
      [].forEach.call(nums,function(n){var to=+n.dataset.to,t0=performance.now();(function st(now){var k=Math.min(1,(now-t0)/1400);n.textContent=fmt(to*(1-Math.pow(1-k,3)),n);if(k<1)requestAnimationFrame(st)})(t0)})})},{threshold:.4});
    io.observe(el);
  }

  var revs=[];
  function rev(el){if(revs.indexOf(el)<0)revs.push(el);onScroll()}
  function onScroll(){revs.forEach(function(el){var r=el.getBoundingClientRect(),k=Math.max(0,Math.min(1,-r.top/Math.max(1,r.height-innerHeight)));el.style.setProperty('--i',(14*(1-k)).toFixed(2)+'%')})}
  addEventListener('scroll',onScroll,{passive:true});

  function tl(el){
    if(el.dataset.ok)return;el.dataset.ok=1;
    var bs=el.querySelectorAll('ol button'),ps=el.querySelectorAll('.pn'),i=0,t;
    function go(n){i=(n+bs.length)%bs.length;[].forEach.call(bs,function(b,k){b.setAttribute('aria-current',k===i)});[].forEach.call(ps,function(p,k){p.classList.toggle('on',k===i)});clearTimeout(t);if(!RM)t=setTimeout(function(){go(i+1)},6000)}
    [].forEach.call(bs,function(b,k){b.addEventListener('click',function(){go(k)})});
    go(0);
  }

  function init(root){
    root=root||document;
    each(root,'.lllp-hero',hero);each(root,'[data-lllp-camp]',camp);each(root,'[data-lllp-rail]',rail);
    each(root,'[data-lllp-cats]',cats);each(root,'.lllp-stats',stats);each(root,'.lllp-rev',rev);each(root,'.lllp-tl',tl);
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',function(){init()});else init();
  document.addEventListener('shopify:section:load',function(e){init(e.target)});
})();
